import React from 'react'
import { Button } from 'react-bootstrap'

const B = (props) => {
  const { style, onClick, icon, iconAlign, children, type, disabled, size } = props
  const icons = {
    forward:'→',
    back:'←',
    chevrondown:<svg x="0px" y="0px" viewBox="0 0 1000 1000" height="12" width="12">
      <g><g transform="matrix(1 0 0 -1 1000 -536) rotate(180)"><path d="M978.4,833.3L877.5,732.9c-7.7-7.7-16.8-11.5-27.4-11.5c-10.5,0-19.7,3.8-27.4,11.5L500,1055.8L177.2,732.9c-7.7-7.7-16.8-11.5-27.4-11.5s-19.7,3.8-27.4,11.5L21.6,833.3C13.9,841,10,850.2,10,860.9c0,10.7,3.9,20,11.6,27.7l451.1,450.5c7.7,7.7,16.8,11.6,27.4,11.6c10.5,0,19.7-3.9,27.4-11.6l451.1-450.5c7.7-7.7,11.6-16.9,11.6-27.7C990,850.2,986.1,841,978.4,833.3z" fill="white"/></g></g>
    </svg>,
    chevronup:<svg x="0px" y="0px" viewBox="0 0 1000 1000" height="12" width="12">
      <g><g transform="matrix(1 0 0 -1 0 1536)"><path d="M978.4,833.3L877.5,732.9c-7.7-7.7-16.8-11.5-27.4-11.5c-10.5,0-19.7,3.8-27.4,11.5L500,1055.8L177.2,732.9c-7.7-7.7-16.8-11.5-27.4-11.5s-19.7,3.8-27.4,11.5L21.6,833.3C13.9,841,10,850.2,10,860.9c0,10.7,3.9,20,11.6,27.7l451.1,450.5c7.7,7.7,16.8,11.6,27.4,11.6c10.5,0,19.7-3.9,27.4-11.6l451.1-450.5c7.7-7.7,11.6-16.9,11.6-27.7C990,850.2,986.1,841,978.4,833.3z" fill="white"/></g></g>
    </svg>
  }
  const types={
    brand: 'primary',
    neutral: 'default',
    destructive: 'danger'
  }
  return(
    <Button style={{position:'relative', 
      paddingRight:icon&&icons[icon]&&iconAlign==="right"?30:12,
      paddingLeft:icon&&icons[icon]&&iconAlign==="left"?30:12,
      ...style
    }} 
      onClick={onClick} bsStyle={types[type]} disabled={disabled} bsSize={size}>
    { icon && icons[icon] && iconAlign && iconAlign==="left" ? 
        <span style={{position:'absolute',left:10}}>{icons[icon]}&nbsp;&nbsp;</span>
      : null }
      {children}
      { icon && icons[icon] && iconAlign && iconAlign==="right" ? 
        <span style={{position:'absolute',right:10}}>&nbsp;&nbsp;{icons[icon]}</span>
      : null }
    </Button>
  )
}

export default B



// WEBPACK FOOTER //
// ./src/lib/themes/lingk/Button.js